module.exports = __webpack_public_path__ + "media/images/pbna-385838b4d7c11637631b3672348fc702.jpg";